
document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.svc-section').forEach(section => {

    const emblaNode = section.querySelector('.embla');
    const videos = [...section.querySelectorAll('.svc-video')];

    const embla = EmblaCarousel(emblaNode, {
      loop: false,           // IMPORTANT FIX (prevents clone bugs)
      align: 'center',
      skipSnaps: false,
      dragFree: false
    });

    let timer = null;

    // ===========================
    // UPDATE ACTIVE SLIDE + VIDEO
    // ===========================
    function update() {

      const index = embla.selectedScrollSnap();

      videos.forEach((video, i) => {

        const card = video.closest('.svc-card');

        if (!card) return;

        if (i === index) {

          card.classList.add('active');

          // reset + play active video
          if (video) {
            try {
              video.currentTime = 0;
              video.play().catch(() => {});
            } catch (e) {}
          }

        } else {

          card.classList.remove('active');

          if (video) {
            video.pause();
          }

        }

      });

    }

    embla.on('select', update);
    embla.on('init', update);

    // ===========================
    // AUTO ROTATE (STABLE VERSION)
    // ===========================
    function stopAuto() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAuto() {

      stopAuto();

      timer = setInterval(() => {

        if (document.hidden) return;

        if (embla.canScrollNext()) {
          embla.scrollNext();
        } else {
          embla.scrollTo(0); // safe reset instead of loop mode
        }

      }, 4500);

    }

    // ===========================
    // INTERACTION HANDLING
    // ===========================

    let paused = false;

    section.addEventListener('mouseenter', () => {
      paused = true;
      stopAuto();
    });

    section.addEventListener('touchstart', () => {
      paused = true;
      stopAuto();
    }, { passive: true });

    section.addEventListener('mousedown', () => {
      paused = true;
      stopAuto();
    });

    section.addEventListener('mouseleave', () => {
      paused = false;
      startAuto();
    });

    // ===========================
    // TAB SWITCH SAFETY
    // ===========================
    document.addEventListener('visibilitychange', () => {

      if (document.hidden) {
        stopAuto();
      } else {
        startAuto();
      }

    });

    // ===========================
    // INIT SAFE ORDER
    // ===========================
    requestAnimationFrame(() => {
      update();
      startAuto();
    });

  });

});